module.exports = __webpack_public_path__ + "static/media/iPhone14-4.48cd2220.png";